import { logoStyles } from "@waytek/Overrides/Widgets/Basic/Logo";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

logoStyles.wrapper = {
    ...logoStyles.wrapper,
    css: css`
        max-width: 243px;
        &&& {
            a {
                span,
                span:hover {
                    text-decoration: none;
                    border-bottom: 0;
                }
            }
        }
    `,
};

logoStyles.img = {
    ...logoStyles.img,
    css: css`
        &&& {
            height: auto;
            width: auto;

            ${mediaQueriesBP.maxMD} {
                height: 50px;
            }

            ${mediaQueriesBP.maxLG} {
                width: auto;
            }
        }
    `,
};
